export const homepageTranslations = {
  en: {
    // Hero
    heroGreeting: 'Meet Finley.',
    heroTitle: 'Your AI guide on your financial journey',
    heroButton: 'Get Finley',
    segmentBegin: 'Begin',
    segmentGrow: 'Grow',
    currentHeroTitle: 'Your money has a next move.',
    currentHeroBeginSubtitle: 'Find out why you run out of money, then fix it with Finley.',
    currentHeroGrowSubtitle: 'Finley maps where you stand and closes the gap to where you want to be.',

    // Frame 2: Missed Opportunity
    frame2Title: 'Not making the most of your money?',
    frame2Intro: 'The cost of inaction is real. And it compounds.',
    frame2Radar: 'I am your radar. I spot opportunities so you don\'t have to.',
    currentFrame2BeginTitle: 'Caught before it costs you.',
    currentFrame2GrowTitle: "Finley keeps an eye on what you're too busy to track.",
    currentFrame2BeginIntro: 'The cost of not knowing adds up.',
    currentFrame2GrowIntro: 'Everyone has blind spots.',
    currentFrame2BeginRadar: "Finley is your radar, spotting what you're missing.",
    currentFrame2GrowRadar: "Finley catches what's drifting before it costs you more.",
    currentFrame2BeginTiles: [
      {
        title: 'Klarna adding up',
        text: '4 open Klarna orders totalling €290. Your next payment hits in 8 days. Want the full picture?',
      },
      {
        title: 'Trim subscriptions?',
        text: "5 streaming services running at €50/month. Hard to know what's actually getting used. Worth a trim?",
      },
      {
        title: 'Café budget almost hit',
        text: '€38 of your €40 café budget spent with 3 days left. Just keeping you in the loop.',
      },
      {
        title: 'Refund just landed',
        text: '€50 back from Zalando. Your bike goal is €180 away. Want to put it straight there?',
      },
    ],
    currentFrame2GrowTiles: [
      {
        title: 'Altersvorsorgedepot is live',
        text: 'The new AV-Depot lets you invest up to €3,000/year in ETFs for retirement. The state adds 15% on top of what you put in, up to €450 a year. Worth setting up.',
      },
      {
        title: 'Your portfolio this week',
        text: 'Markets dropped 2.1% on tariff news. Your portfolio dipped 0.6%. You are well diversified and this is just noise. You are in it for the long run.',
      },
      {
        title: 'Phone contract outdated',
        text: 'You are paying €45/month for 10GB data. Comparable plans start at €12 right now. That is over €390 a year going nowhere. Want to switch?',
      },
    ],

    // Speech bubbles
    bubble1Title: 'Put cash to work?',
    bubble1Text: 'You have €4,500 idling. Inflation is eating into it. Move to ETFs? I can guide you step by step.',
    bubble2Title: 'Boost savings yield',
    bubble2Text: 'Another savings account earns +0.8%. That is ~€120 more this year. Should I move it for you?',
    bubble3Title: 'Trim subscriptions?',
    bubble3Text: 'Streaming totals €50/month. Want to trim a few?',
    bubble4Title: 'Refinancing opportunity',
    bubble4Text: 'A refinance of your mortgage at today\'s rate could save ~€5,000 per year in interest. Explore options?',

    // Frame 3: Out of Reach
    frame3Title: 'You have goals. But does your money know that?',
    frame3Intro: 'It\'s hard to make progress when you cannot see the full picture. Finley connects where you are today to where you want to be.',
    frame3Strategist: 'I\'m your strategist. Let\'s turn your goals into achievable plans.',
    frame3Pills: [
      'Income',
      'Expenses',
      'Savings Rate',
      'Balances',
      'Debt',
      'Investments',
    ],

    // Plan cards
    planSabbatical: 'Sabbatical - \'28',
    planSabbaticalValue: 'Save €500/mo at 2%',
    planWedding: 'Wedding - \'27',
    planWeddingValue: 'Save €100/mo at 2.5%',
    planApartment: 'Apartment - \'30',
    planOnTrack: 'On track',
    currentFrame3BeginTitle: 'You know what you want. It just feels out of reach.',
    currentFrame3GrowTitle: 'You have goals. But is there a plan behind them?',
    currentFrame3BeginSubtitle: 'Finley is your strategist, connecting where you are today to where you want to be.',
    currentFrame3GrowSubtitle: 'Finley is your strategist, coordinating your goals into one plan that holds.',
    currentFrame3BeginPills: ['What comes in', 'What I spend', 'What I save', 'What I owe', 'How fast I can grow'],
    currentFrame3BeginIntro: "Starting is one thing. Staying consistent and knowing you're on track is the other.",
    currentFrame3GrowIntro: "It's hard to work towards all your goals at the same time.",
    currentPlanSabbaticalValue: 'Save €600/mo',
    currentPlanApartmentValue: 'Save €800/mo',
    currentPlanRetirement: "Retirement — '46",
    currentPlanRetirementValue: '€250/mo ETF savings plan',
    currentPlanJapan: "Japan trip — '27",
    currentPlanJapanValue: 'Save €150/mo',
    currentPlanBike: "New bike — '26",
    currentPlanBikeValue: 'Save €50/mo',
    currentPlanEmergency: "Emergency fund — '27",
    currentPlanEmergencyValue: 'Save €200/mo',

    // Frame 4: At Peace
    frame4Title: 'Never at peace with your finances?',
    frame4Intro: 'Daily life pulls you in every direction. It\'s hard to know if your finances can keep up.',
    frame4Pulse: 'I\'m your pulse. I keep an eye on your financial health and direction.',
    frame4PulseCards: {
      spendingLabel: 'Spending',
      spendingStatus: 'Healthy',
      savingsRateLabel: 'Savings rate',
      savingsRateValue: '19% ↑',
      liquidityBufferLabel: 'Liquidity buffer',
      liquidityBufferValue: '3 months ↔',
      goalsLabel: 'Goals',
      goalsStatus: 'On track',
    },
    currentFrame4BeginTitle: 'Never at peace with your finances?',
    currentFrame4GrowTitle: 'Your finances have vitals too. When did you last check them?',
    currentFrame4BeginIntro: 'Not knowing where you stand financially is its own kind of stress.',
    currentFrame4GrowIntro: "Everything's probably fine. Probably.",
    currentFrame4BeginPulse: 'Finley is your pulse, tracking your financial health.',
    currentFrame4GrowPulse: 'Finley is your pulse, running your financial checkup.',
    currentFrame4GrowCards: {
      spendingLabel: 'Fixed costs',
      spendingStatus: 'Up €80 this year',
      savingsRateLabel: 'Savings rate',
      savingsRateValue: '18% avg · 6mo',
      liquidityBufferLabel: 'Investment returns',
      liquidityBufferValue: '',
      goalsLabel: 'Retirement',
      goalsStatus: 'Gap est. at €260/mo',
    },
    currentFrame4BeginCards: {
      spendingLabel: 'Spending',
      spendingStatus: 'High this month',
      savingsRateLabel: 'Saved last month',
      savingsRateValue: '€50',
      liquidityBufferLabel: 'Emergency fund',
      liquidityBufferValue: '€1,300 ✓',
      goalsLabel: 'Money at work',
      goalsStatus: 'Not yet ↔',
    },
    currentFrame4ReturnRows: {
      stocks: 'Stocks',
      crypto: 'Crypto',
      savings: 'Savings',
      avg: 'Avg',
    },

    // Frame 5: FAQ
    faqTitle: 'Frequently Asked Questions',
    faq1Question: 'Why should I trust Finley?',
    faq1Answer: 'Finley combines the expertise of specialised AI agents, from accounting and markets to real estate and tax. Imagine a team of top professionals, working together around the clock to set you up for financial success.',
    faq2Question: 'How does Finley get access to my financial data?',
    faq2Answer: 'Finley connects securely through regulated open-banking interfaces. You simply authenticate once and your credentials stay with your bank, never with us. From there, Finley gathers and analyses your data automatically.',
    faq3Question: 'Is my data safe with Finley?',
    faq3Answer: 'Absolutely. All data is encrypted end-to-end, and Finley only uses it to provide personalised insights. Never for advertising or resale.',
    faq4Question: 'Will Finley take action for me?',
    faq4Answer: 'In the future, Finley will also be able to execute actions on your behalf. Once you decide you\'re ready for that.',
    faq5Question: 'How do I know Finley acts in my best interest?',
    faq5Answer: 'Finley has no products to sell and no commissions to earn. Finley\'s only goal is to improve your outcomes, not to profit from your choices.',

    // Frame 6: Join
    frame6Subtitle: 'Discover what your finances can feel like with a guide by your side.',
    currentFinalTitle: 'Make your next move.',
  },
  de: {
    // Hero
    heroGreeting: 'Das ist Finley.',
    heroTitle: 'Dein Wegbegleiter auf deiner finanziellen Reise',
    heroButton: 'Finley laden',
    segmentBegin: 'Starten',
    segmentGrow: 'Wachsen',
    currentHeroTitle: 'Dein Geld hat einen nächsten Schritt.',
    currentHeroBeginSubtitle: 'Finde heraus, warum dein Geld knapp wird, und ändere es mit Finley.',
    currentHeroGrowSubtitle: 'Finley zeigt dir, wo du stehst, und bringt dich dahin, wo du hinwillst.',

    // Frame 2: Missed Opportunity
    frame2Title: 'Holst du das Beste aus deinem Geld heraus?',
    frame2Intro: 'Die Kosten des Nichtstuns sind real. Und sie wachsen.',
    frame2Radar: 'Ich bin dein Radar. Ich erkenne Chancen, damit du es nicht musst.',
    currentFrame2BeginTitle: 'Erkannt, bevor es teuer wird.',
    currentFrame2GrowTitle: 'Finley behält im Blick, wofür du gerade keine Zeit hast.',
    currentFrame2BeginIntro: 'Nicht zu wissen, was passiert, rechnet sich nicht.',
    currentFrame2GrowIntro: 'Jeder hat blinde Flecken.',
    currentFrame2BeginRadar: 'Finley ist dein Radar und erkennt, was du übersiehst.',
    currentFrame2GrowRadar: 'Finley erkennt, was abdriftet, bevor es dich mehr kostet.',
    currentFrame2BeginTiles: [
      {
        title: 'Klarna summiert sich',
        text: '4 offene Klarna-Bestellungen über insgesamt 290 €. Deine nächste Zahlung ist in 8 Tagen fällig. Willst du den Überblick?',
      },
      {
        title: 'Abos kürzen?',
        text: '5 Streamingdienste laufen für 50 €/Monat. Schwer zu sehen, was du wirklich nutzt. Zeit zum Ausmisten?',
      },
      {
        title: 'Café-Budget fast erreicht',
        text: '38 € deines 40-€-Café-Budgets sind ausgegeben, 3 Tage bleiben. Nur damit du es weißt.',
      },
      {
        title: 'Rückerstattung angekommen',
        text: '50 € zurück von Zalando. Bis zu deinem Fahrrad-Ziel fehlen noch 180 €. Direkt dorthin legen?',
      },
    ],
    currentFrame2GrowTiles: [
      {
        title: 'Altersvorsorgedepot ist da',
        text: 'Mit dem neuen AV-Depot kannst du bis zu 3.000 € pro Jahr für die Rente in ETFs investieren. Der Staat legt 15 % obendrauf, bis zu 450 € im Jahr. Einrichten?',
      },
      {
        title: 'Dein Portfolio diese Woche',
        text: 'Die Märkte sind wegen Zollmeldungen um 2,1 % gefallen. Dein Portfolio liegt 0,6 % im Minus. Du bist gut diversifiziert, das ist nur Rauschen. Du investierst langfristig.',
      },
      {
        title: 'Handyvertrag veraltet',
        text: 'Du zahlst 45 €/Monat für 10 GB Daten. Vergleichbare Tarife starten gerade bei 12 €. Das sind über 390 € im Jahr, die verpuffen. Wechseln?',
      },
    ],

    // Speech bubbles
    bubble1Title: 'Geld arbeiten lassen?',
    bubble1Text: 'Du hast 4.500 € ungenutztes Geld. Die Inflation frisst es auf. In ETFs investieren? Ich führe dich Schritt für Schritt.',
    bubble2Title: 'Sparzinsen erhöhen',
    bubble2Text: 'Ein anderes Sparkonto bringt +0,8%. Das sind ~120 € mehr dieses Jahr. Soll ich es für dich verschieben?',
    bubble3Title: 'Abos reduzieren?',
    bubble3Text: 'Streaming kostet dich 50 €/Monat. Möchtest du ein paar kündigen?',
    bubble4Title: 'Umschuldungschance',
    bubble4Text: 'Eine Umschuldung deiner Hypothek zum aktuellen Zinssatz könnte ~5.000 € pro Jahr an Zinsen sparen. Optionen erkunden?',

    // Frame 3: Out of Reach
    frame3Title: 'Du weißt, was du willst, aber es fühlt sich unerreichbar an?',
    frame3Intro: 'Alles wird teurer. Die großen Schritte im Leben scheinen weiter weg.',
    frame3Strategist: 'Ich bin dein Stratege. Lass uns deine Ziele in erreichbare Pläne verwandeln.',
    frame3Pills: [
      'Einkommen',
      'Ausgaben',
      'Sparquote',
      'Kontostände',
      'Schulden',
      'Investments',
    ],

    // Plan cards
    planSabbatical: 'Sabbatical - \'28',
    planSabbaticalValue: 'Spare 500 €/Mo. bei 2%',
    planWedding: 'Hochzeit - \'27',
    planWeddingValue: 'Spare 100 €/Mo. bei 2,5%',
    planApartment: 'Wohnung - \'30',
    planOnTrack: 'Auf Kurs',
    currentFrame3BeginTitle: 'Du weißt, was du willst. Es fühlt sich nur noch weit weg an.',
    currentFrame3GrowTitle: 'Du hast Ziele. Aber gibt es einen Plan dahinter?',
    currentFrame3BeginSubtitle: 'Finley ist dein Stratege und verbindet, wo du heute stehst, mit dem, wo du hinwillst.',
    currentFrame3GrowSubtitle: 'Finley ist dein Stratege und koordiniert deine Ziele zu einem Plan, der hält.',
    currentFrame3BeginPills: ['Was reinkommt', 'Was ich ausgebe', 'Was ich spare', 'Was ich schulde', 'Wie schnell ich wachsen kann'],
    currentFrame3BeginIntro: 'Anfangen ist das eine. Dranzubleiben und zu wissen, dass du auf Kurs bist, das andere.',
    currentFrame3GrowIntro: 'Es ist schwer, gleichzeitig auf all deine Ziele hinzuarbeiten.',
    currentPlanSabbaticalValue: '600 €/Monat sparen',
    currentPlanApartmentValue: '800 €/Monat sparen',
    currentPlanRetirement: "Rente — '46",
    currentPlanRetirementValue: '250 €/Monat ETF-Sparplan',
    currentPlanJapan: "Japanreise — '27",
    currentPlanJapanValue: '150 €/Monat sparen',
    currentPlanBike: "Neues Fahrrad — '26",
    currentPlanBikeValue: '50 €/Monat sparen',
    currentPlanEmergency: "Notgroschen — '27",
    currentPlanEmergencyValue: '200 €/Monat sparen',

    // Frame 4: At Peace
    frame4Title: 'Nie wirklich entspannt bei deinen Finanzen?',
    frame4Intro: 'Der Alltag zieht dich in alle Richtungen. Es ist schwer zu wissen, ob deine Finanzen mithalten können.',
    frame4Pulse: 'Ich bin dein Puls. Ich behalte deine finanzielle Gesundheit und Richtung im Blick.',
    frame4PulseCards: {
      spendingLabel: 'Ausgaben',
      spendingStatus: 'Gesund',
      savingsRateLabel: 'Sparquote',
      savingsRateValue: '19% ↑',
      liquidityBufferLabel: 'Liquiditätspuffer',
      liquidityBufferValue: '3 Monate ↔',
      goalsLabel: 'Ziele',
      goalsStatus: 'Auf Kurs',
    },
    currentFrame4BeginTitle: 'Nie wirklich entspannt bei deinen Finanzen?',
    currentFrame4GrowTitle: 'Deine Finanzen haben auch Vitalwerte. Wann hast du sie zuletzt geprüft?',
    currentFrame4BeginIntro: 'Nicht zu wissen, wo du finanziell stehst, ist eine eigene Art von Stress.',
    currentFrame4GrowIntro: 'Wahrscheinlich ist alles okay. Wahrscheinlich.',
    currentFrame4BeginPulse: 'Finley ist dein Puls und beobachtet deine finanzielle Gesundheit.',
    currentFrame4GrowPulse: 'Finley ist dein Puls und macht deinen Finanz-Check.',
    currentFrame4GrowCards: {
      spendingLabel: 'Fixkosten',
      spendingStatus: 'Dieses Jahr +80 €',
      savingsRateLabel: 'Sparquote',
      savingsRateValue: '18 % Ø · 6 Mon.',
      liquidityBufferLabel: 'Investmentrendite',
      liquidityBufferValue: '',
      goalsLabel: 'Rente',
      goalsStatus: 'Lücke ca. 260 €/Monat',
    },
    currentFrame4BeginCards: {
      spendingLabel: 'Ausgaben',
      spendingStatus: 'Diesen Monat hoch',
      savingsRateLabel: 'Letzten Monat gespart',
      savingsRateValue: '50 €',
      liquidityBufferLabel: 'Notgroschen',
      liquidityBufferValue: '1.300 € ✓',
      goalsLabel: 'Geld arbeitet',
      goalsStatus: 'Noch nicht ↔',
    },
    currentFrame4ReturnRows: {
      stocks: 'Aktien',
      crypto: 'Krypto',
      savings: 'Tagesgeld',
      avg: 'Ø',
    },

    // Frame 5: FAQ
    faqTitle: 'Häufig gestellte Fragen',
    faq1Question: 'Warum sollte ich Finley vertrauen?',
    faq1Answer: 'Finley kombiniert das Fachwissen spezialisierter KI-Agenten aus Buchhaltung, Märkten, Immobilien und Steuern. Stell dir ein Team von Top-Experten vor, die rund um die Uhr zusammenarbeiten, um dich finanziell erfolgreich zu machen.',
    faq2Question: 'Wie bekommt Finley Zugang zu meinen Finanzdaten?',
    faq2Answer: 'Finley verbindet sich sicher über regulierte Open-Banking-Schnittstellen. Du authentifizierst dich einmal und deine Zugangsdaten bleiben bei deiner Bank, niemals bei uns. Von dort sammelt und analysiert Finley deine Daten automatisch.',
    faq3Question: 'Sind meine Daten bei Finley sicher?',
    faq3Answer: 'Absolut. Alle Daten sind Ende-zu-Ende verschlüsselt, und Finley nutzt sie nur, um personalisierte Einblicke zu geben. Niemals für Werbung oder Weiterverkauf.',
    faq4Question: 'Wird Finley Aktionen für mich ausführen?',
    faq4Answer: 'In Zukunft wird Finley auch in der Lage sein, Aktionen in deinem Namen auszuführen. Sobald du dafür bereit bist.',
    faq5Question: 'Woher weiß ich, dass Finley in meinem besten Interesse handelt?',
    faq5Answer: 'Finley hat keine Produkte zu verkaufen und keine Provisionen zu verdienen. Finleys einziges Ziel ist es, deine Ergebnisse zu verbessern, nicht von deinen Entscheidungen zu profitieren.',

    // Frame 6: Join
    frame6Subtitle: 'Entdecke, wie sich deine Finanzen anfühlen können, mit einem Wegbegleiter an deiner Seite.',
    currentFinalTitle: 'Mach deinen nächsten Schritt.',
  },
} as const

export type HomepageLocale = keyof typeof homepageTranslations
